import { IonContent, IonPage, IonImg, useIonViewDidLeave } from '@ionic/react';
import { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { PdfContext } from '../components/PdfViewer';

const SafetySyllabus: React.FC = () => {
  const { setModalVisible, setDesktopPdf, setMobilePdf } = useContext(PdfContext);
  const [swiper, setSwiper] = useState<SwiperCore>();
  // set the swiper slide to the first one when the component is mounted
  useIonViewDidLeave(() => {
    swiper?.slideTo(0);
  }, [swiper]);
  return (
    <>
      <IonPage>
        <IonContent fullscreen>
          <Swiper
            initialSlide={0}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            onSwiper={(swiper) => setSwiper(swiper)}
            slidesPerView={1}
            // loop={true}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={0}
            centeredSlides={true}
            breakpoints={{
              768: {
                slidesPerView: 1.2,
                spaceBetween: -20
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: -120
              },
            }}
          >
            <SwiperSlide>
              <div className="container-inner">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#ff00c2', color: '#fff' }}>Hội thảo về An toàn</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030', paddingTop: '0.1rem' }}>
                    <p>
                      Bắt sóng tần số với người mới quen luôn là điều khá hào hứng nhưng nó chỉ thực sự thú vị chỉ khi bạn đặt sự an toàn của bản thân lên hàng đầu! Cùng khám phá toàn bộ hướng dẫn bên dưới về cách tận dụng tối đa trải nghiệm tương hợp mà vẫn đảm bảo được sự an toàn của bạn khi trực tuyến lẫn ngoài đời. Chúng tôi đề cập đến vấn đề an toàn về Nhận thức, Ranh giới và Sự Đồng thuận cùng vô số những vấn đề khác.
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#fd5466', color: '#fff' }}>Chuyên đề về An toàn</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Không phải con gà hay quả trứng, mà sự an toàn của bạn phải được đặt lên đầu tiên!</p>
                    <IonImg className="hide-mobile" src='assets/img/safety-seminar-thumb-01.jpg'></IonImg>
                    <IonImg className="hide-desktop" src='assets/img/safety-seminar-thumb-01-mobile.jpg'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Không phải con gà hay quả trứng, mà sự an toàn của bạn phải được đặt lên đầu tiên!</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_Safety.pdf");
                        setMobilePdf("/assets/pdf/VN_Safety(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#fd5466" }}>Giữ an toàn</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#186ac4', color: '#fff' }}>Khóa học cơ bản về sự đồng thuận</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Hướng dẫn về cách đánh dấu ranh giới và giao tiếp rõ ràng!</p>
                    <IonImg src='assets/img/safety-consent-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Hướng dẫn về cách đánh dấu ranh giới và giao tiếp rõ ràng!</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_Consent.pdf");
                        setMobilePdf("/assets/pdf/VN_Consent(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#186ac4" }}>Hiểu về Đồng thuận</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </IonContent>
      </IonPage>
    </>
  );
};

export default SafetySyllabus;
